import React from 'react';
import { Button, ButtonProps } from 'react-aria-components';

import styles from './button.module.scss';

interface AriaButtonProps extends ButtonProps {
	variant?: 'primary' | 'secondary' | 'tertiary';
	size?: 'small' | 'large' | 'giant' | 'auto';
}

const AriaButton = React.forwardRef<HTMLButtonElement, AriaButtonProps>(
	({ variant = 'tertiary', size, className, ...props }, ref) => {
		return (
			<Button
				ref={ref}
				className={[styles[`button-${variant}`], size && styles[`button-${size}`], className].join(
					' ',
				)}
				{...props}
			/>
		);
	},
);

AriaButton.displayName = 'AriaButton';
export { AriaButton };
